


import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';


platformBrowser().bootstrapModule(AppModule, {
  ngZone: 'zone.js',
  ngZoneEventCoalescing: true, // opcional
  ngZoneRunCoalescing: true    // opcional

}).catch(err => console.error(err));
